import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'modules';
import moment from 'moment';
import { ERoute } from 'enums/route.enum';
import styled from 'styled-components';
import ArrowRight from './arrow-right.svg';

function InterviewMasterClassBasicFloatingButton() {
  const history = useHistory();

  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const isInterviewMasterClassBasicAvailable = currentUser?.is_interview_master_class_basic_available;
  const interview_master_class_basic_end_datetime = moment(
    currentUser?.interview_master_class_basic_end_datetime,
  ).format('YYYY-MM-DD HH:mm');

  const handleClickCTA = () =>
    isInterviewMasterClassBasicAvailable
      ? history.push(ERoute.LectureInterviewMasterClassBasicVideoPlayer)
      : history.push('/purchase/interview-master-class-basic');

  return (
    <StyledContainer>
      {/* left */}
      <div className='left'>
        <h5 className='title'>
          전략컨설팅 인터뷰 <strong>MasterClass [기초편]</strong>
        </h5>

        <div className='price-info'>
          <div className='original-price'>550,000원</div>
          <div className='arrow'>
            <img src={ArrowRight} alt='arrow-right' />
          </div>
          <div className='final-price'>
            <span>11</span>0,000원
          </div>
          <div className='vat'>VAT 포함</div>
        </div>
      </div>

      {/* right */}
      <div className='right'>
        {isInterviewMasterClassBasicAvailable && (
          <span className='endDatetime'>만료일 : {interview_master_class_basic_end_datetime}</span>
        )}
        <button className='cta' onClick={handleClickCTA}>
          {isInterviewMasterClassBasicAvailable ? '시청하기' : '결제하기'}
        </button>
      </div>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  background-color: white;
  border-radius: 15px;
  height: 120px;
  width: 100%;
  max-width: 1320px;
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: rgba(153, 153, 153, 0.08) 0px 2px 6px;
  border: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  z-index: 1;

  .left {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 20px;
      font-weight: 400;
      margin-bottom: 5px;

      strong {
        font-weight: 700;
      }
    }

    .price-info {
      display: flex;
      column-gap: 15px;
      align-items: center;

      .original-price {
        font-size: 16px;
        font-weight: 500;
        color: #999;
        text-decoration: line-through;
        line-height: 21px;
        padding-top: 2px;
      }

      .final-price {
        font-size: 20px;
        font-weight: 700;
        color: black;

        span {
          letter-spacing: -1.5px;
        }
      }

      .vat {
        font-size: 14px;
        font-weight: 500;
        color: #999;
        margin-left: -3px;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
    .endDatetime {
      font-weight: 400;
      color: #555;
      font-size: 15px;
      margin-right: 25px;
    }

    .cta {
      all: unset;
      box-sizing: border-box;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 18px;
      font-weight: 700;
      background-color: #3cac40;
      width: 300px;
      height: 60px;
      cursor: pointer;
    }
  }
`;

export default InterviewMasterClassBasicFloatingButton;
